// src/api/reportApi.js
import axios from 'axios';

const BASE_URL = 'https://education-backend.liara.run/api/report';

const getAuthHeader = () => {
  const token = localStorage.getItem('teacherToken');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

// existing functions kept, now use getAuthHeader consistently
export const getLinkedStudents = async () => {
  const res = await axios.get('https://education-backend.liara.run/api/report/linked-students', {
    headers: getAuthHeader()
  });
  return res.data;
};

export const getStudentSummary = async () => {
  return axios.get(`${BASE_URL}/students`, { headers: getAuthHeader() })
    .then(res => res.data);
};

export const getProgressOverTime = async (studentId) => {
  return axios.get(`${BASE_URL}/student/${studentId}/progress`, { headers: getAuthHeader() })
    .then(res => res.data);
};

export const getAnswerHistory = async (studentId) => {
  return axios.get(`${BASE_URL}/student/${studentId}/history`, { headers: getAuthHeader() })
    .then(res => res.data);
};

export const getFilteredReport = async (filters) => {
  return axios.post(`${BASE_URL}/filter`, filters, { headers: getAuthHeader() })
    .then(res => res.data);
};

export const getActivityLogs = async () => {
  return axios.get(`https://education-backend.liara.run/api/admin/logs`, { headers: getAuthHeader() })
    .then(res => res.data);
};

export const getClassRecords = async (studentId) => {
  const API_BASE = process.env.REACT_APP_API_BASE || 'https://education-backend.liara.run/api';
  const res = await axios.get(`${API_BASE}/class-records?studentId=${studentId}`, {
    headers: getAuthHeader()
  });
  return res.data;
};

export const addClassRecord = async (payload) => {
  const res = await axios.post('https://education-backend.liara.run/api/class-records', payload, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeader() }
  });
  return res.data;
};

export const deleteClassRecord = async (id) => {
  const res = await axios.delete(`https://education-backend.liara.run/api/class-records/${id}`, {
    headers: getAuthHeader()
  });
  return res.data;
};

export const getQuestionsForTeacher = async () => {
  const res = await axios.get('https://education-backend.liara.run/api/question/by-teacher', {
    headers: getAuthHeader()
  });
  return res.data;
};

export const createQuestion = async (payload) => {
  const res = await axios.post('https://education-backend.liara.run/api/student/question/add', payload, {
    headers: { 'Content-Type': 'application/json', ...getAuthHeader() }
  });
  return res.data;
};

export const deleteQuestion = async (id) => {
  const res = await axios.delete(`https://education-backend.liara.run/api/question/${id}`, {
    headers: getAuthHeader()
  });
  return res.data;
};

// getTeacherLessons: اگر نقش Admin باشد تلاش می‌کند admin endpoint را بگیرد، در غیر این صورت مسیر فعلی
export const getTeacherLessons = async () => {
  const role = localStorage.getItem('teacherRole');
  const tokenHeaders = getAuthHeader();

  // مسیرهای سرور (اگر admin endpoint موجود باشد)
  const adminUrl = 'https://education-backend.liara.run/api/attendance/admin/lessons';
  const teacherUrl = 'https://education-backend.liara.run/api/lesson/by-teacher';

  if (role === 'Admin') {
    // تلاش اولیه برای admin endpoint
    try {
      const res = await axios.get(adminUrl, { headers: tokenHeaders, validateStatus: s => s < 500 });
      if (res.status === 200 && Array.isArray(res.data)) return res.data;
      // اگر admin endpoint پاسخی نداد، fallback به teacherUrl ادامه می‌یابد
    } catch (e) {
      // swallow and fallback
      console.warn('admin lessons endpoint failed, falling back to teacher endpoint', e);
    }
  }

  // fallback برای همه حالات: مسیر معلم (ممکن است برای Admin خالی باشد اما حداقل تلاش شود)
  const res = await axios.get(teacherUrl, { headers: tokenHeaders });
  return res.data; // انتظار: [{ id, title }, ...]
};

// temporary: call actual backend route that currently exists
export async function getLessonStudentsMasid(lessonId, opts = {}) {
  const token = localStorage.getItem('teacherToken');
  const API_BASE = process.env.REACT_APP_API_BASE || 'https://education-backend.liara.run/api';
  const url = `${API_BASE}/lesson/students-masid/${encodeURIComponent(lessonId)}`;
  const params = {
    page: opts.page ?? 1,
    pageSize: opts.pageSize ?? 50,
    search: opts.search ?? '',
    includeRecords: !!opts.includeRecords,
    teacherScoped: opts.teacherScoped ?? true
  };
  return axios.get(url, { headers: token ? { Authorization: `Bearer ${token}` } : {}, params, validateStatus: s => s < 500 });
}